<template>
    <div class="plain">
        <slot />
    </div>
</template>

<style lang="scss" scoped>
.plain {
    background: $body-bg;
}
</style>
